import React from 'react';
import { Helmet } from 'react-helmet';

const TermsMain = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Terms of Service - U Brand It</title>
                <meta name="description" content="U Brand It Terms of Service - Terms and conditions for using our promotional products and services." />
            </Helmet>

            {/* Page Header Start */}
            <section className="page-header">
                <div className="page-header__bg" style={{backgroundImage: 'url(/assets/images/backgrounds/page-header-bg.jpg)'}}></div>
                <div className="container">
                    <div className="page-header__inner">
                        <h2>Terms of Service</h2>
                        <div className="thm-breadcrumb__box">
                            <ul className="thm-breadcrumb list-unstyled">
                                <li><a href="/">Home</a></li>
                                <li><span>·</span></li>
                                <li>Terms of Service</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Page Header End */}

            {/* Terms Content Start */}
            <section className="terms-of-service">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="terms-of-service__content">
                                <div className="terms-of-service__text-box">
                                    <h3>Terms of Service</h3>
                                    <p><strong>Last updated:</strong> January 2024</p>
                                    
                                    <h4>Acceptance of Terms</h4>
                                    <p>By accessing and using U Brand It services, you accept and agree to be bound by the terms and provision of this agreement.</p>

                                    <h4>Services Description</h4>
                                    <p>U Brand It provides promotional products, branded merchandise, custom apparel, and related design services to businesses and organizations.</p>

                                    <h4>Orders and Payment</h4>
                                    <ul>
                                        <li>All orders are subject to acceptance and availability</li>
                                        <li>Prices are subject to change without notice</li>
                                        <li>Payment terms are specified on each order confirmation</li>
                                        <li>Rush orders may incur additional charges</li>
                                    </ul>

                                    <h4>Product Specifications</h4>
                                    <ul>
                                        <li>Products are manufactured to industry standards</li>
                                        <li>Colors may vary slightly from digital representations</li>
                                        <li>Custom artwork must be provided in specified formats</li>
                                        <li>Proofs must be approved before production begins</li>
                                    </ul>

                                    <h4>Delivery and Shipping</h4>
                                    <ul>
                                        <li>Delivery times are estimates and not guaranteed</li>
                                        <li>Shipping costs are additional unless otherwise specified</li>
                                        <li>Risk of loss transfers upon delivery to carrier</li>
                                    </ul>

                                    <h4>Returns and Cancellations</h4>
                                    <ul>
                                        <li>Custom products are non-returnable unless defective</li>
                                        <li>Cancellations must be requested before production begins</li>
                                        <li>Defective products will be replaced at no charge</li>
                                    </ul>

                                    <h4>Intellectual Property</h4>
                                    <p>Customer warrants they have the right to use all artwork, logos, and designs provided. U Brand It is not responsible for trademark or copyright infringement.</p>

                                    <h4>Limitation of Liability</h4>
                                    <p>U Brand It's liability shall not exceed the purchase price of the products involved. We are not liable for indirect, special, or consequential damages.</p>

                                    <h4>Contact Information</h4>
                                    <p>For questions about these terms, contact us:</p>
                                    <p>
                                        <strong>U Brand It</strong><br />
                                        Phone: <a href="tel:8007215822" style={{color: 'inherit'}}>800-721-5822</a><br />
                                        Email: <a href="mailto:general@ubranditpa.com" style={{color: 'inherit'}}>general@ubranditpa.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Terms Content End */}
        </React.Fragment>
    );
};

export default TermsMain;